// extracted by mini-css-extract-plugin
export default {"card":"TableCard_card__RGess","toolbar":"TableCard_toolbar__QiumT","pagination":"TableCard_pagination__XE2nj","tableWrapper":"TableCard_tableWrapper__5RPrH"};